import { useEffect, useRef, useState } from 'react';

// useEffect, который выполняется только при изменении зависимостей (componentDidUpdate)
export const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};

export const useFiltration: UseFiltration = (props) => {
  const {
    filters: initialFilters = {},
    sorters: initialSorters = { name: '', direction: 0 },
  } = props;
  const [filters, setFilters] = useState(initialFilters);
  const [sorters, setSorters] = useState(initialSorters);

  return {
    setFilters,
    setSorters,
    filters,
    sorters,
  };
};

export const usePagination: UsePagination = (props) => {
  const { limit: initialLimit, page: initialPage } = props;
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);

  return { setPage, setLimit, page, limit };
};
